var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuForm',{attrs:{"breadcrumbs":_vm.breadcrumbs,"value":Object.assign({}, _vm.defaultNew, {menuCategories: []})},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var form = ref.form;
var fields = ref.fields;
return [_c('v-btn',{staticClass:"mx-2",attrs:{"disabled":!form,"color":"success","rounded":""},on:{"click":function($event){return _vm.create(fields)}}},[_vm._v(" Create ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }